import styled from 'styled-components';
import { colorSuccess } from '@atlas-frontend/design-tokens';

export const TextSuccess = styled.span`
  color: ${colorSuccess};
`;
